// extracted by mini-css-extract-plugin
export var quillEditor = "_hx-1";
export var variable = "_hx-0";